export const SEARCH_RESULTS_MAX_DISPLAY = 5;
export const SEARCH_TEXT_TRIGGER_LENGTH = 5;

export const MANUAL_ADDRESS = 'manual_address';
export const E04_CONTENT = `Sorry. We couldn't find your addres`;
export const E05_CONTENT = `Enter address manually`;
export const SB_FAIL = 'address_fail';

export const MANUAL_OPTION = {
	value: MANUAL_ADDRESS,
	label: E05_CONTENT,
};
